import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      toast.success("Welcome to the house. You're on the list.");
      setEmail("");
    } catch (err) {
      if (err.response?.status === 409) toast.info("You're already on the list.");
      else toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section data-testid="newsletter-section" className="border-b border-black/10">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-20 md:py-28 grid md:grid-cols-2 gap-10 items-end">
        <Reveal>
          <p className="overline-label">Private List</p>
          <h2 className="font-serif-brand text-4xl md:text-5xl font-light mt-4 leading-tight">
            First access to<br />limited releases.
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <form onSubmit={submit} className="flex items-end gap-4" data-testid="newsletter-form">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email address"
              data-testid="newsletter-email-input"
              className="input-minimal"
            />
            <button
              type="submit"
              disabled={loading}
              data-testid="newsletter-submit-button"
              className="shrink-0 h-11 w-11 flex items-center justify-center border border-[#BA8D53] text-[#BA8D53] hover:bg-[#BA8D53] hover:text-white transition-colors duration-300 disabled:opacity-50"
              aria-label="Subscribe"
            >
              <ArrowRight size={18} strokeWidth={1.5} />
            </button>
          </form>
        </Reveal>
      </div>
    </section>
  );
}
